function getConfig(name, defaultValue = null) {
	// If inside a docker container, use window.ENV
	if (window.ENV !== undefined) {
		return window.ENV[name] || defaultValue;
	}

	return process.env[name] || defaultValue;
}

export function getBackendUrl() {
  const u = getConfig("REACT_APP_BACKEND_URL");
  if (u && String(u).trim() !== "") {
    return String(u).trim().replace(/\/$/, "");
  }
  return "http://localhost:8080";
}

export function getWhatsAppGoUrl() {
  const u = getConfig("REACT_APP_WHATSAPP_GO_URL");
  if (u && String(u).trim() !== "") {
    return String(u).trim().replace(/\/$/, "");
  }
  return "http://localhost:8081";
}

export function getNotificameApiUrl() {
  const u = getConfig("REACT_APP_NOTIFICAME_API_URL");
  if (u && String(u).trim() !== "") {
    return String(u).trim().replace(/\/$/, "");
  }
  return "https://api.notificame.com.br";
}

export function getWhatsAppGoWsUrl() {
  const base = getWhatsAppGoUrl();
  if (base.startsWith("https://")) {
    return `${base.replace(/^https/, "wss")}/ws`;
  }
  return `${base.replace(/^http/, "ws")}/ws`;
}

export function getFrontNome() {
	return getConfig('REACT_APP_NOME');
}

export function getFrontLogo() {
	return getConfig('REACT_APP_LOGO');
}

export function getFrontendUrl() {
	return getConfig('REACT_APP_FRONTEND_URL');
}

export function getHoursCloseTicketsAuto() {
	return getConfig('REACT_APP_HOURS_CLOSE_TICKETS_AUTO');
}

export function getPM2ID() {
	return getConfig('PM2_ID');
}

export function getSystemVersion() {
	return getConfig("REACT_APP_SYSTEM_VERSION", "2.0.0");
}

/** ISO yyyy-mm-dd (ex.: 2026-05-20) */
export function getSystemReleaseDate() {
	return getConfig("REACT_APP_SYSTEM_RELEASE_DATE", "");
}

export function formatSystemReleaseDateBr(iso) {
	if (!iso || typeof iso !== "string") return "";
	const parts = iso.trim().split("-");
	if (parts.length !== 3) return iso;
	const [y, m, d] = parts;
	return `${d}/${m}/${y}`;
}

export function getSystemVersionLabel() {
	const version = getSystemVersion();
	const release = formatSystemReleaseDateBr(getSystemReleaseDate());
	return release ? `v${version} · ${release}` : `v${version}`;
}
